module.exports = __webpack_public_path__ + "static/praxisSpiele_bw-c6fb9c499db55ec5cefc0838b56f4d44.jpg";